import { getData, queryString } from '@/util/Axios'

export const ApiEntityProperties = (axios, obuBaseUrl) => {
  axios.setBaseURL(obuBaseUrl)

  const load = async (id, module = 'accommodations') => {
    const result = await axios.get(`/api/entities/${module}/${id}/properties`)
    return result.data
  }

  const save = async (id, payload, module = 'accommodations') => {
    const result = await axios.post(`/api/entities/${module}/${id}/properties`, payload)
    return result.data
  }

  return {
    entityPropertiesLoad: load,
    entityPropertiesSave: save
  }
}
